import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { trackClickEvent } from "../../mixpanel";
import { useAuth } from "../../contexts/Auth";
import { useBasicInfo } from "../../contexts/BasicInfo";
import { useGeneralProfile } from "../../contexts/Organization";
import { treatment_program } from "../../constants/common";

const MarketingContent = ({
  item,
  showTitle = true,
  showFooter = true,
  component = "Marketing Card",
}) => {
  const { permissions, userData, account_type } = useAuth();
  const { data: userInfo } = useBasicInfo();
  const { facilityInfo } = useGeneralProfile();

  const info = account_type === treatment_program ? facilityInfo : userInfo;

  const handleButton = (e) => {
    e.stopPropagation();
    if (permissions?.marketing_data) {
      trackClickEvent("Clicked Carousel Content", {
        page: "Homepage",
        component: component,
        button: item?.dynamic_btn_text,
        action: "CTA button 1",
        cardId: item?.id,
        partnerName: item?.title,
        compaignType: item?.campaign_type,
        paymentType: item?.payment_type,
        data: new Date(item?.created_at).toLocaleDateString("en-US", {
          month: "short",
          year: "numeric",
        }),
        account_type: account_type,
        roles: info?.roles,
      });
      window.open(item?.dynamic_btn_url, "_blank");
    }
  };

  const handleSecondaryButton = (e) => {
    e.stopPropagation();
    if (permissions?.marketing_data) {
      trackClickEvent("Learn More Marketing", {
        page: "Homepage",
        component: component,
        button: item?.dynamic_btn2_text,
        action: "CTA button 2",
        cardId: item?.id,
        partnerName: item?.title,
        compaignType: item?.campaign_type,
        paymentType: item?.payment_type,
        data: new Date(item?.created_at).toLocaleDateString("en-US", {
          month: "short",
          year: "numeric",
        }),
        account_type: account_type,
        roles: info?.roles,
      });
      window.open(item?.dynamic_btn2_url, "_blank");
    }
  };

  return (
    <>
      {showTitle && (
        <Box>
          <Typography
            variant="body1"
            color="text.primary"
            fontWeight={700}
            sx={{ cursor: "text" }}
          >
            What's Happening on TTN
          </Typography>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              backgroundColor: "divider",
              mt: 1,
              mb: 1,
            }}
          />
          {item?.heading && (
            <Typography
              variant="h6"
              font-size="14px"
              color="text.primary"
              fontWeight={700}
              sx={{ cursor: "text" }}
            >
              {item.heading}
            </Typography>
          )}
        </Box>
      )}

      {item?.dynamic_btn_text && (
        <Button
          variant="contained"
          onClick={handleButton}
          sx={{
            alignSelf: "center",
            width: "100%",
            maxWidth: "300px",
            borderRadius: 5,
          }}
          disabled={!permissions?.marketing_data}
        >
          {item?.dynamic_btn_text || "Register West"}
        </Button>
      )}

      {item?.dynamic_btn2_text && (
        <Button
          variant="contained"
          onClick={handleSecondaryButton}
          sx={{
            alignSelf: "center",
            width: "100%",
            maxWidth: "300px",
            borderRadius: 5,
          }}
          disabled={!permissions?.marketing_data}
        >
          {item?.dynamic_btn2_text || "Register East"}
        </Button>
      )}

      {showFooter && (
        <>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              backgroundColor: "divider",
              mt: 1,
              mb: -1,
            }}
          />
          <Typography
            variant="body2"
            color="text.primary"
            p={0}
            fontWeight={500}
            sx={{ cursor: "text" }}
          >
            Interested in being featured?
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            fontSize={12}
            sx={{ cursor: "text" }}
          >
            Email us at <a href="mailto:team@thettn.com">team@thettn.com</a> to learn
            more
          </Typography>
        </>
      )}
    </>
  );
};

export default MarketingContent;
